export default "__VITE_ASSET__Bw4uzAt4__"